import { responseList } from "@/mocks/guaMore";

const avatarPalette = ["bg-red-700", "bg-amber-500", "bg-orange-600"];

export default function Responses() {
  return (
    <section id="response" className="w-full bg-white">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-2 text-center">
          <p className="text-xs font-semibold tracking-[0.2em] text-red-700">当事人最新回应</p>
          <h2 className="font-masthead text-2xl font-black text-stone-900 md:text-3xl">
            各方回应，原话为你汇总
          </h2>
          <p className="mx-auto max-w-2xl text-sm text-stone-500">
            我们只收录当事人或代表方的公开原话，完整保留各方立场，避免断章取义。
          </p>
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-3">
          {responseList.map((r, i) => (
            <figure key={r.name} className="flex flex-col rounded-xl border border-orange-900/10 bg-[#faf6ee] p-5">
              <div className="mb-3 flex items-center gap-3">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-full ${avatarPalette[i % avatarPalette.length]} text-base font-bold text-white`}
                >
                  {r.name.slice(0, 1)}
                </span>
                <div>
                  <figcaption className="text-sm font-bold text-stone-900">{r.name}</figcaption>
                  <p className="text-xs text-stone-400">{r.role}</p>
                </div>
              </div>
              <blockquote className="flex-1">
                <p className="relative rounded-lg border border-orange-900/10 bg-white p-4 text-sm leading-relaxed text-stone-600">
                  <i className="ri-double-quotes-l absolute -top-3 left-3 text-xl text-red-700"></i>
                  {r.content}
                </p>
              </blockquote>
              <div className="mt-3 flex items-center justify-between text-xs text-stone-400">
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {r.time}
                </span>
                <span className="rounded-full bg-red-50 px-2 py-0.5 font-medium text-red-700">公开原话</span>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}